export default class Arrays {

  public static range(length: number, step: number) {
    return Array.from({ length }, (v, k) => step * k)
  }
}
